import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Florida Blue (Blue Cross Blue Shield of Florida)",
  shortName: "Florida Blue",
  slug: "florida-blue-insurance",
  seoTitle: "Florida Blue TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Florida Blue policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Florida Blue TMS coverage, Florida Blue SPRAVATO authorization, Florida Blue mental health benefits Coral Springs FL, Florida Blue depression treatment Florida",
};

export const FloridaBlueInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default FloridaBlueInsurance;
